var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIco24CommunicationSendOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_24_communication_send_outlined",
    "data-name": "ico / 24 / communication / send_outlined",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_color",
    "data-name": "Icon color",
    d: "M11.476,18h-.16a.511.511,0,0,1-.459-.29L7.471,10.523.292,7.134A.511.511,0,0,1,0,6.675v-.16A.5.5,0,0,1,.331,6l16.726-6A.457.457,0,0,1,17.143,0a.447.447,0,0,1,.085.008.5.5,0,0,1,.349.139l.26.26a.5.5,0,0,1,.139.519L11.945,17.67A.5.5,0,0,1,11.476,18ZM11.161,6.017a.5.5,0,0,1,.344.138l.38.38a.5.5,0,0,1,0,.689L10.328,8.914a1.992,1.992,0,0,0-.339,2.21l1.228,2.659L15.131,2.857,4.216,6.775,6.872,8a2,2,0,0,0,2.256-.29l1.688-1.56A.5.5,0,0,1,11.161,6.017Z",
    transform: "translate(2.998 3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco24CommunicationSendOutlined);
export default __webpack_public_path__ + "static/media/ico - 24 - communication - send_outlined.4d2ebdfb6e01c5e5adf3d2856685da9c.svg";
export { ForwardRef as ReactComponent };